// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max'

/** 添加用户数据 @author houyunfei POST /user/add */
export async function addUser(body: API.UserAddForm, options?: { [key: string]: any }) {
    return request<API.BaseResponseLong>('/user/add', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: body,
        ...(options || {}),
    })
}

/** 用户封禁/解封 @author houyunfei POST /user/ban */
export async function banUser(body: API.UserBanForm, options?: { [key: string]: any }) {
    return request<API.BaseResponse>('/user/ban', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: body,
        ...(options || {}),
    })
}

/** 批量删除用户数据 @author houyunfei POST /user/batchDelete */
export async function deleteUserByBatch(body: API.IdListForm, options?: { [key: string]: any }) {
    return request<API.BaseResponseLong>('/user/batchDelete', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: body,
        ...(options || {}),
    })
}

/** 获取当前用户信息 @author houyunfei GET /user/current */
export async function getCurrentUser(options?: { [key: string]: any }) {
    return request<API.BaseResponseUserVO>('/user/current', {
        method: 'GET',
        ...(options || {}),
    })
}

/** 删除单个用户数据 @author houyunfei GET /user/delete */
export async function deleteUserById(
    // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
    params: API.deleteUserByIdParams,
    options?: { [key: string]: any },
) {
    return request<API.BaseResponseLong>('/user/delete', {
        method: 'GET',
        params: {
            ...params,
        },
        ...(options || {}),
    })
}

/** 发送邮箱验证码  绑定邮箱 POST /user/email/send/bind */
export async function sendEmailBind(body: API.UserEmailBindForm, options?: { [key: string]: any }) {
    return request<API.BaseResponse>('/user/email/send/bind', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: body,
        ...(options || {}),
    })
}

/** 验证邮箱验证码  绑定邮箱 POST /user/email/verify/bind */
export async function verifyEmailBind(body: API.UserEmailBindForm, options?: { [key: string]: any }) {
    return request<API.BaseResponse>('/user/email/verify/bind', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: body,
        ...(options || {}),
    })
}

/** 获取用户概览信息 @author soldier GET /user/overview/${param0} */
export async function getUserOverview(
    // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
    params: API.getUserOverviewParams,
    options?: { [key: string]: any },
) {
    const { userId: param0, ...queryParams } = params
    return request<API.BaseResponseUserVO>(`/user/overview/${param0}`, {
        method: 'GET',
        params: { ...queryParams },
        ...(options || {}),
    })
}

/** 发送手机验证码 绑定手机号 POST /user/phone/send/bind */
export async function sendBind(body: API.UserPhoneBindForm, options?: { [key: string]: any }) {
    return request<API.BaseResponse>('/user/phone/send/bind', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: body,
        ...(options || {}),
    })
}

/** 验证手机验证码 绑定手机号 POST /user/phone/verify/bind */
export async function verifyBind(body: API.UserPhoneBindForm, options?: { [key: string]: any }) {
    return request<API.BaseResponse>('/user/phone/verify/bind', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: body,
        ...(options || {}),
    })
}

/** 获取当前登录用户信息 @author houyunfei GET /user/public/getLoginUser */
export async function getLoginUser(options?: { [key: string]: any }) {
    return request<API.BaseResponseUserVO>('/user/public/getLoginUser', {
        method: 'GET',
        ...(options || {}),
    })
}

/** 根据ID查询用户数据 @author houyunfei GET /user/query */
export async function queryUserById(
    // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
    params: API.queryUserByIdParams,
    options?: { [key: string]: any },
) {
    return request<API.BaseResponseUserVO>('/user/query', {
        method: 'GET',
        params: {
            ...params,
        },
        ...(options || {}),
    })
}

/** 分页查询用户数据 @author houyunfei POST /user/queryPage */
export async function queryUserByPage(body: API.UserQueryForm, options?: { [key: string]: any }) {
    return request<API.BaseResponsePageResultUserVO>('/user/queryPage', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: body,
        ...(options || {}),
    })
}

/** 更新用户数据 @author houyunfei POST /user/update */
export async function updateUser(body: API.UserUpdateForm, options?: { [key: string]: any }) {
    return request<API.BaseResponseLong>('/user/update', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: body,
        ...(options || {}),
    })
}

/** 更新用户基础信息(用户个人设置) @author soldier POST /user/updateBase */
export async function updateUserBase(body: API.UserUpdateBaseForm, options?: { [key: string]: any }) {
    return request<API.BaseResponseLong>('/user/updateBase', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: body,
        ...(options || {}),
    })
}
